import api from './api';

const authService = {
  // ============================================
  // Authentication endpoints (/api/cms/auth)
  // ============================================

  login: async (email, password) => {
    return api.post('/api/cms/auth/login', { email, password });
  },

  verify2FA: async (temporaryToken, code) => {
    return api.post('/api/cms/auth/verify-2fa', { temporaryToken, code });
  },

  logout: async () => {
    // Backend blacklists the token on logout
    return api.post('/api/cms/auth/logout');
  },

  getCurrentUser: async () => {
    return api.get('/api/cms/auth/me');
  },

  refreshToken: async () => {
    return api.post('/api/cms/auth/refresh');
  },

  // ============================================
  // Password Reset endpoints (/api/cms/auth)
  // ============================================

  forgotPassword: async (email) => {
    return api.post('/api/cms/auth/forgot-password', { email });
  },

  verifyResetToken: async (token) => {
    return api.get(`/api/cms/auth/verify-reset-token?token=${token}`);
  },

  resetPassword: async (token, newPassword) => {
    return api.post('/api/cms/auth/reset-password', { token, newPassword });
  },

  // ============================================
  // Two-Factor Authentication endpoints (/api/auth/2fa)
  // ============================================

  enable2FA: async () => {
    return api.post('/api/auth/2fa/enable');
  },

  disable2FA: async () => {
    return api.post('/api/auth/2fa/disable');
  },

  get2FAStatus: async () => {
    return api.get('/api/auth/2fa/status');
  },

  regenerateBackupCodes: async () => {
    return api.post('/api/auth/2fa/backup-codes/regenerate');
  },

  // ============================================
  // Profile endpoints (using admin user endpoints)
  // ============================================

  updateProfile: async (userId, data) => {
    return api.put(`/api/admin/users/${userId}`, data);
  },

  changePassword: async (userId, newPassword) => {
    return api.patch(`/api/admin/users/${userId}/password`, { newPassword });
  },
};

export default authService;
